export const FETCH_REPOSITORY_ORGANIZATION_USAGE_REQUEST = '@repository/FETCH_REPOSITORY_ORGANIZATION_USAGE_REQUEST';
export const FETCH_REPOSITORY_ORGANIZATION_USAGE_SUCCESS = '@repository/FETCH_REPOSITORY_ORGANIZATION_USAGE_SUCCESS';
export const FETCH_REPOSITORY_ORGANIZATION_USAGE_FAILED = '@repository/FETCH_REPOSITORY_ORGANIZATION_USAGE_FAILED';
